<template>
  <div class="payTotal">
    <div class="payTotalWrap">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        style="height: 40px;margin-top: 10px"
        v-if="!isFullscreen"
        label-width="70px"
      >
        <el-row>
          <el-col :span="5">
            <el-form-item label="项目部" prop="deptId">
              <el-select
                v-model="searchForm.deptId"
                placeholder="请选择"
                @change="changeDept"
              >
                <el-option
                  v-for="item in deptIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="项目名称" prop="projectId">
              <el-select
                v-model="searchForm.projectId"
                placeholder="请选择"
                clearable
                @change="changeProject"
              >
                <el-option
                  v-for="item in projectIdList"
                  :key="item.projectId"
                  :label="item.projectName"
                  :value="item.projectId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="日期">
              <el-date-picker
                v-model="searchForm.enterDate"
                value-format="yyyy-MM"
                type="month"
                :picker-options="pickerOptions"
                placeholder="请选择"
                :clearable="false"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="项目状态" prop="projectProcess">
              <el-select v-model="searchForm.projectProcess" placeholder="请选择" clearable>
                <el-option
                  v-for="process in processStatusListForSelect"
                  :key="process.id"
                  :label="process.value"
                  :value="process.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <div label-width="0" style="text-align: center;width: 100%; white-space: nowrap">
              <el-button type="primary" @click="searchAll">查询</el-button>
              <el-button type="info" @click="reset">重置</el-button>
              <!-- <el-button type="primary" @click="changeSource">数据源</el-button> -->
              <div class="enlarge" @click="deptSet" v-if="!searchForm.deptId">
                <i class="el-icon-setting"></i>
              </div>
              <div class="enlarge" @click="enlargeClick">
                <i class="el-icon-zoom-in"></i>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <el-form :inline="true" style="height: 40px;margin-top: 10px;text-align:right" v-else>
        <el-form-item label style="float: right">
          <div class="enlarge" @click="narrowClick">
            <i class="el-icon-zoom-out"></i>
          </div>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
      <dataCenter31 ref="dataCenter31" v-show="dataSource===31"></dataCenter31>
      <dataCenter32 ref="dataCenter32" v-show="dataSource===32"></dataCenter32>
      <dataCenter33 ref="dataCenter33" v-show="dataSource===33"></dataCenter33>
    </div>
    <deptSet ref="deptSeting" @getDept="refreshDept"></deptSet>
  </div>
</template>

<script>
import {
  getProcessStatusList //获取项目状态下拉列表数据
} from "../../services/financeService";
import {
  earningCostqueryDeptListApi, //获取项目部下拉列表数据
  earningCostqueryProjectListAPi //获取项目名称下拉列表数据
} from "@/services/financeService";
import {
  getPayMaxDate,
  getPayDropDownDept,
  getPayDropDownProject
} from "../../services/dataCenterAService";
import {
  getsubDeptService, //获取项目部二级项目级联列表
} from "@/services/sysSettingService";
import dataCenter31 from "./payAppliable";
import dataCenter32 from "./payProjectDeptDataSingle";
import dataCenter33 from "./payProjectData";
import deptSet from "./setDeptDialog";

export default {
  name: "payTotal",
  components: { dataCenter33, dataCenter32, dataCenter31,deptSet},
  data() {
    return {
      dataSource: 31,
      searchForm: {
        deptId: "",
        deptName: "",
        projectId: "",
        projectName: "",
        enterDate: "",
        projectProcess: ""
      },
      processStatusListForSelect: [], //项目状态的可选项
      deptIdList: [],
      projectIdList: [],
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      maxDate: "",
      isFullscreen: false,
      resizeTimer2: null
    };
  },
  activated() {
    let _this = this;
    if (_this.resizeTimer1) clearTimeout(_this.resizeTimer1);
    _this.resizeTimer1 = setTimeout(function() {
      _this.setWrapWH();
    }, 50);
  },
  beforeDestroy(){
    if (this.resizeTimer2) clearTimeout(this.resizeTimer2);
  },
  mounted() {
    let _this = this;
    /*------------------*/
    this.setWrapWH();
    this.getProcessStatusListForSelect();
    // window.onresize = () => {
    //     return (() => {
    //         this.setWrapWH()
    //     })();
    // };

    window.addEventListener("resize", function() {
      if (_this.resizeTimer2) clearTimeout(_this.resizeTimer2);
      _this.resizeTimer2 = setTimeout(function() {
        _this.setWrapWH();
      }, 50);
    });
    /*------------------------------*/
    this.isFullscreen = false;
    if (
      this.$route.params &&
      (this.$route.params.deptId ||
        this.$route.params.projectId ||
        this.$route.params.enterDate)
    ) {
      this.isFullscreen = true;
      this.fullScreen();
    }
    if (document.getElementById("aside")) {
      this.isFullscreen = false;
    }
    getPayMaxDate().then(res => {
      if (res.code === 10000000) {
        this.searchForm.enterDate = res.data;
        this.maxDate = res.data;
        setTimeout(() => {
          this.searchAll();
        }, 10);
      }
    });
    //获取项目部
    this.getDept();
    //获取项目
    this.getProject();
    this.bus.$on("navMenuChange", nav => {
      if (nav === "payAppliable") {
        _this.setWrapWH();
      }
    });
  },
  methods: {
    refreshDept() {
      this.getDept();
      this.searchAll();
    },
    setWrapWH() {
      //外面div大小
      let ch = document.documentElement.clientHeight;
      let cw = document.documentElement.clientWidth - 40;
      // 里面的div大小
      let chw = document.documentElement.clientHeight;
      let cww = document.documentElement.clientWidth - 40;
      if (document.getElementById("aside")) {
        // ch = ch - 50 - 90
        ch = ch - 50 - 30;
        cw = cw - 280;
        chw = chw - 50 - 30;
        cww = cww - 280;
      }
      if (chw < 800) {
        chw = 800;
      }
      if (cww < 1600) {
        cww = 1600;
      }
      document.getElementsByClassName("payTotal")[0].style.height = ch + "px";
      setTimeout(() => {
        this.setWrapWH1();
      }, 30);
    },
    setWrapWH1() {
      if (this.searchForm.projectId) {
        this.dataSource = 33;
        this.$refs.dataCenter33.setWrapHeight();
      } else if (this.searchForm.deptId) {
        this.dataSource = 32;
        this.$refs.dataCenter32.setWrapHeight();
      } else {
        this.dataSource = 31;
        this.$refs.dataCenter31.setWrapHeight();
      }
    },
    disabledDate(time) {
      // return time.getTime() > new Date(this.maxDate);
      return false;
    },
    searchAll() {
      this.setWrapWH();

      if (this.$route.params && this.$route.params.enterDate) {
        this.searchForm.enterDate = this.$route.params.enterDate;
        this.$route.params.enterDate = "";
      }
      if (this.$route.params && this.$route.params.deptId) {
        this.searchForm.deptId = this.$route.params.deptId;
        this.$route.params.deptId = "";
      }
      if (this.$route.params && this.$route.params.projectId) {
        this.searchForm.projectId = this.$route.params.projectId;
        this.$route.params.projectId = "";
      }
      if (this.$route.params && this.$route.params.projectProcess) {
        this.searchForm.projectProcess = this.$route.params.projectProcess;
        this.$route.params.projectProcess = "";
      }
      if (!this.searchForm.enterDate) {
        return;
      }
      if (this.searchForm.projectId) {
        this.dataSource = 33;
        // this.$refs.dataCenter33.setWrapHeight();
        this.$refs.dataCenter33.search(this.searchForm);
      } else if (this.searchForm.deptId) {
        this.dataSource = 32;
        // this.$refs.dataCenter32.setWrapHeight();
        this.$refs.dataCenter32.search(this.searchForm);
      } else {
        this.dataSource = 31;
        // this.$refs.dataCenter31.setWrapHeight();
        this.$refs.dataCenter31.search(this.searchForm);
      }
    },
    reset() {
      this.$refs["searchForm"].resetFields();
      this.projectIdList = [];
    },
    //获取项目状态下拉列表
    getProcessStatusListForSelect() {
      getProcessStatusList()
        .then(res => {
          if (res.code == "10000000") {
            this.processStatusListForSelect = res.data || [];
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    getDept() {
      //   getPayDropDownDept().then(res => {
      //     if (res.code === 10000000) {
      //       this.deptIdList = res.data;
      //     }
      //   });
      // earningCostqueryDeptListApi()
      //   .then(res => {
      //     if (res.code == "10000000") {
      //       this.deptIdList = res.data || [];
      //     }
      //   })
      //   .catch(() => {});
      let param = {};
      param.deptId = 101;
      getsubDeptService(param).then((res) => {
        if (res.code == 10000000) {
          this.deptIdList = res.data;
          // this.getDeptData();
        }
      });
    },
    getProject() {
      //   let params = {};
      //   if (this.searchForm.deptId) {
      //     params.deptId = this.searchForm.deptId;
      //   }
      //   getPayDropDownProject(params).then(res => {
      //     if (res.code === 10000000) {
      //       this.projectIdList = res.data;
      //     }
      //   });
      if (this.searchForm.deptId) {
        earningCostqueryProjectListAPi({
          deptId: this.searchForm.deptId
        })
          .then(res => {
            if (res.code == "10000000") {
              this.projectIdList = res.data || [];
            }
          })
          .catch(() => {});
      }
    },
    //切换项目部
    changeDept() {
      let index = this.deptIdList.findIndex(
        item => item.id === this.searchForm.deptId
      );
      this.searchForm.deptName = this.deptIdList[index].name;
      this.searchForm.projectId = "";
      this.getProject();
    },
    //切换项目名称
    changeProject() {
      let index = this.projectIdList.findIndex(
        item => item.projectId === this.searchForm.projectId
      );
      if(index!==-1)
      {
      this.searchForm.projectName = this.projectIdList[index].projectName;
      }
    },
    //切换数据源
    changeSource() {
      let memberData = {};
      this.bus.$emit("navMenuChange", {
        routeId: "payDataSource",
        routeParam: memberData
      });
    },
      //设置部门
      deptSet() {
      // this.showFlag=true;
      this.$refs.deptSeting.showDeptDialog('PAY');
    },
    //放大
    enlargeClick() {
      this.$router.push({ name: "payTotalA", params: this.searchForm });
      // let routeUrl = this.$router.resolve({
      //     name: 'accountsReceiveTotal', params: this.searchForm
      // });
      // window.open(routeUrl .href, '_blank');
      this.fullScreen();
    },
    fullScreen() {
      let el = document.documentElement;
      let rfs =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullscreen;
      if (typeof rfs != "undefined" && rfs) {
        rfs.call(el);
      }
      return;
    },
    //    取消F11缩小
    narrowClick() {
      if (
        (document.body.scrollHeight === window.screen.height &&
          document.body.scrollWidth === window.screen.width) ||
        (window.outerHeight === window.screen.height &&
          window.outerWidth === window.screen.width)
      ) {
        let el = document.documentElement;
        let cfs =
          el.requestFullScreen ||
          el.webkitRequestFullScreen ||
          el.mozRequestFullScreen ||
          el.msRequestFullscreen;
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        if (typeof cfs != "undefined" && cfs) {
          cfs.call(el);
        }
      }
      this.$router.back();
    }
  }
};
</script>

<style scoped lang="scss">
.payTotal {
  height: calc(100%);
  text-align: left;
  overflow: auto;
  background: #ffffff;
  padding: 10px;

  .payTotalWrap {
    overflow: hidden;
  }

  /deep/ .el-form-item__content {
    width: calc(100% - 80px);

    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 100%;
    }
  }
  .el-form-item {
    width: 100%;
  }
  .el-select {
    width: 100%;
  }
  .el-input {
    width: 100%;
  }

  .enlarge {
    display: inline-block;
    width: 40px;
    font-size: 30px;
    vertical-align: middle;
    text-align: right;

    i {
      color: #069dbc;
    }
  }

  .el-divider--horizontal {
    margin: 15px 0 5px;
  }
  /deep/.el-input--suffix .el-input__inner {
    padding-right: 0;
  }
}
</style>

